import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { styled } from "@mui/material/styles";

const ChatSearchMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "20px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "70%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
  },
}));
const ChatSearchWrap = styled("div")(({ theme }) => ({
  background: "#E3E3E3",
  width: "100%",
  height: "50px",
  padding: "5px 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));
const SearchInputMain = styled("div")(({ theme }) => ({
  width: "95%",
  display: "flex",
  alignItems: "center",
  background: "#FFFFFF",
  border: "1px solid #E8E8E8",
  height: "40px",
  padding: "0px 7px",
  "& img": { marginRight: "5px" },
  "& input": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
    color: "rgba(30, 39, 56, 0.5)",
    border: "none",
    width: "100%",
    height: "100%",
    "&:focus": { border: "none", outline: "none" },
  },
}));
const ChatBtn = styled("div")(({ theme }) => ({
  width: "4%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#FFFFFF",
  height: "40px",
  "& button": {
    border: "none",
    outline: "none",
    background: "#FFFFFF",
  },
}));
const SearchButton = styled(ArrowForwardIcon)(({ theme }) => ({
  fontSize: "20px",
  cursor: "pointer",
}));
const DebounceInputMain = styled("div")(({ theme }) => ({
  input: {
    width: "100%",
    height: "48px",
    background: "#F2F2F2",
    borderRadius: "10px",
    border: "1px solid transparent",
    fontFamily: theme.typography.fontFamily,
    padding: "10px",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
  },
}));
const UsersList = styled("div")(({ theme }) => ({
  marginTop: "10px",
  "& .UserList": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    borderBottom: "1px solid #F2F2F2",
    padding: "8px 5px",
    cursor: "pointer",
  },
}));

export {
  ChatSearchMain,
  ChatSearchWrap,
  SearchInputMain,
  ChatBtn,
  SearchButton,
  DebounceInputMain,
  UsersList,
};
